export const OffersDataService = {
    getOffersData() {
        const {
            faqData,
            isShownFaqSection,
            isShownGamesSection,
            isShownMobileAppSection,
            isShownPromotionsSection,
            mainBanner: {
                buttonText,
                description,
                essentialTnC,
                fullTnC,
                html,
                image,
                mobileImage,
            },
            mainBannerLayout,
            mobileAppData: {
                links: {
                    android,
                    ios,
                },
                mainImage,
                subtitle,
                title,
            },
            pagePurpose,
            promotionsData
        } = window?.offersPageData?.offersPageData || {};
        const { globalComponentsVisibility } = window?.offersPageData || {};

        return {
            faqData,
            isShownFaqSection,
            isShownGamesSection,
            isShownMobileAppSection,
            isShownPromotionsSection,
            buttonText,
            description,
            essentialTnC,
            fullTnC,
            html,
            image,
            mobileImage,
            mainBannerLayout,
            mainImage,
            subtitle,
            title,
            android,
            ios,
            pagePurpose,
            promotionsData,
            globalComponentsVisibility
        };
    },
};
